import { FC } from "react"
import { StyledSchedule } from "../Shop/StyledShop"

const Schedule: FC<{ schedule?: string }> = ({ schedule }) => {
  return <>{!!schedule && <StyledSchedule>{schedule}</StyledSchedule>}</>
}

export { Schedule }
